import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { FileTextIcon, ZapIcon, BookOpenIcon, ShieldCheckIcon, LockIcon, CreditCardIcon, StarIcon } from 'lucide-react';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/nJUdgtPu9hQwVz94XZrBU9/ChatGPT_Image_22_jul_2026,_12_47_26_(1).png';
const badges = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: BookOpenIcon,
  label: 'Los 12 meses'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}];
export function HeroSection() {
  return <section className="relative overflow-hidden border-b border-[var(--olive)]/30" data-id="element-101" data-mp="2rrpgi6dwazbu">
      {/* subtle olive glow */}
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-[var(--olive)]/20 blur-[120px]" aria-hidden="true" data-id="element-102" data-mp="3fh06cstpj9b7" />
      <div className="relative mx-auto max-w-6xl px-4 py-16 sm:py-20 lg:py-24" data-id="element-103" data-mp="2fg1sp6zkbq2h">
        <div className="grid items-center gap-12 lg:grid-cols-2" data-id="element-104" data-mp="2beye0nt9402u">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-105" data-mp="2p51wd3p0f9n0">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-[var(--gold)]/40 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--gold-light)]" data-id="element-106" data-mp="2kcihm3el68gm">
              🧘 Tu Plataforma Digital™
            </p>
            <h1 className="font-serif-display text-4xl font-bold leading-[1.05] text-[var(--cream)] sm:text-5xl md:text-6xl" data-id="element-107" data-mp="384fttvly72i9">
              Todo tu año de Pilates.
            </h1>
            <p className="mt-5 text-lg font-semibold text-[var(--olive-light)]" data-id="element-108" data-mp="1dpwq5ppo6syn">
              S.O.S. Pilates — Super Kit Completo
            </p>
            <p className="mt-2 text-white/60" data-id="element-109" data-mp="18smsxnw1hd09">
              El sistema número uno para profesoras y profesores de Pilates en
              Argentina
            </p>
            <p className="mt-5 max-w-lg text-white/75" data-id="element-110" data-mp="3drwcvxiy32fl">
              Clases planificadas + progresiones + sustitutos IEC listos para
              usar. Sin buscar. Sin armar. Sin perder domingos.
            </p>

            <div className="mt-6 flex flex-wrap gap-2" data-id="element-111" data-mp="3mu5hy7vg23ll">
              {badges.map(b => <span key={b.label} className="inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-1.5 text-sm text-white/80" data-id="element-112" data-mp="3rsyv1z6tjsl8">
                  <b.icon className="h-4 w-4 text-[var(--gold)]" aria-hidden="true" data-id="element-113" data-mp="5dxih0bmfp47" />
                  {b.label}
                </span>)}
              <span className="inline-flex items-center gap-2 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-1.5 text-sm text-white/80" data-id="element-114" data-mp="edkhxgksikum">
                🇦🇷 Para Argentina
              </span>
            </div>

            <div className="mt-8 max-w-md" data-id="element-115" data-mp="23uoel1lko1wh">
              <CtaButton variant="gold" data-id="element-116" data-mp="23sbnnyxu6h7a">Quiero mi Super Kit ahora</CtaButton>
            </div>

            <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-white/60" data-id="element-117" data-mp="1yu0elqfd8aq4">
              {trust.map(t => <span key={t.label} className="inline-flex items-center gap-1.5" data-id="element-118" data-mp="1puwv4lcadtb3">
                  <t.icon className="h-4 w-4 text-[var(--olive-light)]" aria-hidden="true" data-id="element-119" data-mp="2mkwe79q2ca7x" />
                  {t.label}
                </span>)}
            </div>

            <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm font-semibold text-[var(--cream)]" data-id="element-120" data-mp="2ik4125e2ll6d">
              <span data-id="element-121" data-mp="28tiwm1bptmfj">+300 profes</span>
              <span className="text-[var(--olive)]" data-id="element-122" data-mp="28sg6hvm7vo0o">·</span>
              <span data-id="element-123" data-mp="368wr5l80gyt2">6 Tomos</span>
              <span className="text-[var(--olive)]" data-id="element-124" data-mp="36952v9sedy2o">·</span>
              <span data-id="element-125" data-mp="36aq2vexhe97x">6 Bonos</span>
              <span className="text-[var(--olive)]" data-id="element-126" data-mp="31hwumh2t0ir3">·</span>
              <span className="inline-flex items-center gap-1" data-id="element-127" data-mp="31gc0utobd3ua">
                4.9/5
                <StarIcon className="h-4 w-4 fill-[var(--gold)] text-[var(--gold)]" aria-hidden="true" data-id="element-128" data-mp="2l4s3a7c70jr5" />
              </span>
            </div>
          </motion.div>

          <motion.div className="relative" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} data-id="element-129" data-mp="2c30xz3lkeext">
            <div className="pointer-events-none absolute inset-0 rounded-full bg-[var(--gold)]/10 blur-3xl" aria-hidden="true" data-id="element-130" data-mp="34r6h5lwyzvvj" />
            <img src={HERO_IMAGE} alt="Super Kit S.O.S. Pilates: caja del sistema completo con 6 tomos y 6 bonos para profesores de Pilates" className="relative mx-auto w-full max-w-xl drop-shadow-2xl" data-id="element-131" data-mp="2v1mwqbtlztyk" />
          </motion.div>
        </div>
      </div>
    </section>;
}